import { useNeedsLinkedInReauth } from 'features/linked-in-status'
import { useLinkedInReauth } from 'features/linkedin-login/LinkedInReauthProvider'
import type { KeyboardEvent, MouseEvent } from 'react'

import dangerIcon from '../../../assets/image/icons/svg/icons/danger.svg'
import css from './LinkedInNotLogged.module.scss'
import { useLinkedInInfo } from './useLinkedInInfo'

function LinkedInNotLogged() {
	const { isLoading, needsReauth } = useNeedsLinkedInReauth()
	if (isLoading || !needsReauth) {
		return null
	}

	const result = <NotLoggedInner />
	return result
}

function NotLoggedInner() {
	const { linkedInfo } = useLinkedInInfo()
	const { start } = useLinkedInReauth()

	const openReauth = () => {
		start()
	}

	const handleBannerClick = (event: MouseEvent<HTMLElement>) => {
		if (event.defaultPrevented) {
			return
		}

		openReauth()
	}

	const handleBannerKeyDown = (event: KeyboardEvent<HTMLElement>) => {
		if (event.key !== 'Enter' && event.key !== ' ') {
			return
		}

		event.preventDefault()
		openReauth()
	}

	const profileLabel = linkedInfo
		? `${linkedInfo.givenName} ${linkedInfo.familyName}`
		: 'your linked'

	return (
		<article
			className={css.root}
			onClick={handleBannerClick}
			onKeyDown={handleBannerKeyDown}
			role='button'
			tabIndex={0}
			title='Sign in with your linked LinkedIn account'
		>
			<img
				alt='danger icon'
				className={css.icon}
				height={14}
				src={dangerIcon}
				width={14}
			/>

			<span>
				You are not logged in to LinkedIn with{' '}
				<span className={css.profileName}>{profileLabel} account.</span> Click to
				sign in.
			</span>
		</article>
	)
}

export { LinkedInNotLogged, useLinkedInInfo }
